import { useEffect, useState } from 'react';
import { getProducts, formatUGX, buildOrderLink, buildWaLink } from 'features/misc/api/getProducts';
import { Link } from 'react-router-dom';

export function Hero() {
  const [heroProducts, setHeroProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;

    getProducts()
      .then((products) => {
        if (cancelled) return;
        const hero = products.filter((p) => p.hero && p.stock).slice(0, 3);
        setHeroProducts(hero);
      })
      .catch(() => {
        // Hero cards are decorative — fail quietly and just show none
        // rather than breaking the whole landing section.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="relative overflow-hidden bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,rgba(0,229,160,0.08)_0%,transparent_70%)] px-4 pb-20 pt-24 text-center sm:px-8">
      <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent/25 bg-accent-dim px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-accent">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent" />
        Kampala · Same-day delivery
      </span>

      <h1 className="mx-auto max-w-3xl text-[clamp(2.4rem,6vw,4.2rem)] font-black leading-[1.1] tracking-tight">
        Gadgets that move
        <br />
        <span className="text-accent">as fast as you do.</span>
      </h1>

      <p className="mx-auto mt-5 max-w-md text-text-muted">
        Phones, laptops, earbuds and accessories — genuine stock, real prices, no shop visits
        needed. Pick what you want, send one message, get it delivered.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/shop"
          className="rounded-full bg-accent px-7 py-3 text-sm font-extrabold text-black transition-all hover:-translate-y-0.5 hover:bg-accent-dim hover:shadow-lg hover:shadow-accent/30"
        >
          Browse catalog
        </Link>
        <a
          href={buildWaLink('Hi Chikwafu, I have a question about a gadget')}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full border border-white/10 px-7 py-3 text-sm font-bold transition-colors hover:border-white/30 hover:bg-white/5"
        >
          Ask us anything
        </a>
      </div>

      {heroProducts.length > 0 && (
        <div className="mt-16 flex flex-wrap justify-center gap-4">
          {heroProducts.map((product) => (
            <HeroCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
}

function HeroCard({ product }) {
  return (
    <div className="w-44 rounded-2xl border border-white/10 bg-card p-4 text-left shadow-lg shadow-black/40">
      <img
        src={product.img}
        alt={product.name}
        className="mb-3 h-28 w-full rounded-lg object-cover"
      />
      <div className="mb-1 text-[0.68rem] font-bold uppercase tracking-wide text-accent">
        {product.cat}
      </div>
      <div className="text-sm font-bold leading-snug">{product.name}</div>
      <div className="mt-1 text-sm font-extrabold text-accent">UGX {formatUGX(product.price)}</div>
      <a
        href={buildOrderLink(product)}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 block text-xs font-bold text-text-muted transition-colors hover:text-accent"
      >
        Order on WhatsApp →
      </a>
    </div>
  );
}
